export default () => ({
  accentcolor: '',
//   backdrop: false,
//   menusection: 'Magazine',
  menuHeight: 500,
  isHomePage: false,
  menuOff: false,
  darkmode: false,
  showCart: false,
  scrollDist: 0,
  current: window.location.pathname,
  mobileMenu: false,
  isMobile: window.matchMedia('only screen and (max-width: 760px)').matches, 
  clamp(num, min, max) {
    return Math.min(Math.max(num, min), max); 
  },
//   mapNumRange(num, inMin, inMax, outMin, outMax) {
//     return ((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
//   },

  lightOrDark(color) {
      if(color == '#dc0d19') {
          return 'dark'
      } else {
          if (color.match(/^rgb/)) {
              color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
              r = color[1];
              g = color[2];
              b = color[3];
          } else {
              color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
              r = color >> 16;
              g = color >> 8 & 255;
              b = color & 255;
          }
          hsp = Math.sqrt(
              0.299 * (r * r) +
              0.587 * (g * g) +
              0.114 * (b * b)
          );
          // Using the HSP value, determine whether the color is light or dark
          if (hsp>70) {
              return 'light';
          } 
          else {
              return 'dark';
          }
      }
  },
  copyToClipboard(message) {
      var text = message;
      navigator.clipboard.writeText(text).then(function() {
          console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
          console.error('Async: Could not copy text: ', err);
      });
  }
});